import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getMe } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    const token = localStorage.getItem('amazonia_token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const res = await getMe();
      setUser(res.data);
    } catch {
      localStorage.removeItem('amazonia_token');
      localStorage.removeItem('amazonia_user');
      setUser(null);
    }
    setLoading(false);
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const login = (token, userData) => {
    localStorage.setItem('amazonia_token', token);
    localStorage.setItem('amazonia_user', JSON.stringify(userData));
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('amazonia_token');
    localStorage.removeItem('amazonia_user');
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';
  const isPro = user?.role === 'professional' && user?.status === 'validated';
  const isPending = user?.status === 'pending';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, isAdmin, isPro, isPending, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
